import { Avatar, Box, Tooltip } from "@material-ui/core";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import filterIcon from "../../assets/Customer/Filter.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import Search from "../../components/SearchTab/Search";
import Toast from "../../components/ToastContainer/CustomToast";
import BrowserLanguage from "../../components/Util/BrowserLanguage";
import { exportDealerReportsLogs } from "../../services/Invitations/ExportDealerService";
import { getListSettingsById } from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import { getDealers } from "../../slices/Dealer/DealerSlice";
import CommonUtil from "../../Util/CommonUtils";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import ExportDialog from "../DailyReports/ExportDialog";
import DealerReportFilter from "./DealerReportFilter";
import DealerTransactionAndReportExports from "./DealerTransactionAndReportExports";

let language = BrowserLanguage.getDefaultLanguage();

function DealersReport() {
  const [clear, setClear] = React.useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageSize, setPageSize] = useState(0);
  const history = useHistory();
  const [fileFormat, setFileFormat] = useState("1");
  const [noOfRecords, setNoOfRecords] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [toInputValue, setToInputValue] = useState("");
  const [isLivePhoto, setIsLivePhoto] = useState(false);
  const [isSignature, setIsSignature] = useState(false);
  const [closemodel, setClosemodel] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [openDownload, setOpenDownload] = useState(false);
  const [rowDealer, setRowDealer] = useState({});
  const companyId = localStorage.getItem("companyId");
  const [date, setDate] = useState();
  const [loading, setLoading] = useState(true);
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 10,
  });

  const [filter, setFilter] = React.useState({
    status: "",
    name: "",
    email: "",
  });

  const defaultFilter = {
    status: "",
    name: "",
    email: "",
  };

  const handleChange = (newPage, size) => {
    setLoading(true);
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging]);

  const loadData = (filter, paging) => {
    dispatch(getDealers(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if ((data.code = "MSGS4007")) {
          setTotalRecords(data.data.totalCount);
          setRows(data.data.companies);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setLoading(false);
        } else {
          setRows([]);
        }
      })
      .catch((er) => {});
  };

  useEffect(() => {
    dispatch(getListSettingsById(companyId))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          if (data.data.adminAndDealerDateFormat === "MM/DD/YYYY") {
            setDate("MM/dd/yyyy HH:mm");
          }
        }
      });
  }, []);

  const handleFileFormatChange = (event) => {
    setFileFormat(event.target.value);
  };

  const handleDataRecordsChange = (event) => {
    setNoOfRecords(event.target.value);
  };

  const handleCheckBoxLivePhoto = (event) => {
    setIsLivePhoto(event.target.checked);
  };
  const handleCheckBoxSignature = (event) => {
    setIsSignature(event.target.checked);
  };
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setInputValue(value);
    }
  };

  const handleToInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setToInputValue(value);
    }
  };

  const handleExportCustomer = (data) => {
    if (fileFormat == "2") {
      setIsLivePhoto(false);
      setIsSignature(false);
    }
    var searchParam = "";
    if (filter.name !== undefined && !CommonUtil.isEmptyString(filter.name)) {
      searchParam += "&name=" + encodeURIComponent(filter.name);
    }
    if (filter.email !== undefined && !CommonUtil.isEmptyString(filter.email)) {
      searchParam += "&email=" + encodeURIComponent(filter.email);
    }
    if (filter.type !== undefined && !CommonUtil.isEmptyString(filter.type)) {
      searchParam += "&type=" + filter.type;
    }
    if (
      filter.status !== undefined &&
      !CommonUtil.isEmptyString(filter.status)
    ) {
      searchParam += "&status=" + filter.status;
    }

    const stats = {
      fileType: fileFormat,
      from: inputValue === "" ? "0" : inputValue,
      to: toInputValue === "" ? "0" : toInputValue,
    };

    dispatch(exportDealerReportsLogs(onSuccess, onFailure, stats, searchParam))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          onSuccess();
        } else {
          onFailure();
        }
      })
      .catch((er) => {});
  };

  const onSuccess = () => {
    setClosemodel(true);

    return Toast(t("EXPORTSUCC001"), "success");
  };

  const onFailure = () => {
    Toast(t("COMMON000"), "error");
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 20) {
      return text.substring(0, 20) + "...";
    } else {
      return text;
    }
  };

  const globalsearch = (searchedVal) => {
    const filteredRows = rows.filter((test) => {
      const lowerCaseSearchedVal = searchedVal.toLowerCase().trim();

      return (
        (test.name
          ? test.name.toLowerCase().includes(lowerCaseSearchedVal)
          : "") ||
        (test.email
          ? test.email.toLowerCase().includes(lowerCaseSearchedVal)
          : "") ||
        (test.status
          ? test.status.trim().toLowerCase() === lowerCaseSearchedVal
          : "") ||
        (test.phone
          ? test.phone.toLowerCase().includes(lowerCaseSearchedVal)
          : "") ||
        (test.adminName
          ? test.adminName.toLowerCase().includes(lowerCaseSearchedVal)
          : "") ||
        (test.customerName
          ? String(test.customerName)
              .toLowerCase()
              .includes(lowerCaseSearchedVal)
          : "") ||
        `${test.name}`.toLowerCase().includes(lowerCaseSearchedVal)
      );
    });
    setRows(filteredRows);
  };

  const handleFilterIcon = () => {
    setOpenFilter(true);
  };

  const applyFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      status: data.status,
      name: data.name,
      email: data.email,
    });
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { firstName, lastName, imagePreSignedURL } = params.row;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${firstName?.charAt(0) || ""}${lastName?.charAt(0) ||
      ""}`;
    const bgColor = !imagePreSignedURL
      ? getAvatarColor(initials)
      : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = imagePreSignedURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };

  const columns = React.useMemo(() => [
    {
      field: "company.profile",
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return ZoomHandaler(params);
      },
    },

    {
      field: "company Name",
      headerName: t("CUSTDATABLE01"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.name,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "adminName",
      headerName: t("CUSTDATABLE04"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.adminName,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "email",
      headerName: t("CUSTDATABLE02"),
      flex: 1,
      minWidth: 180,
      valueGetter: (params) => params.row.email,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "mobile",
      headerName: t("CUSTDATABLE03"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.phone,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },
    {
      field: "customerName",
      headerName: t("CUSTDATABLE21"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.customerName,
    },

    // {
    //   field: "Actions",
    //   headerName: t("CUSTDATABLE16"),
    //   type: "actions",
    //   flex: 1,
    //   minWidth: 165,
    //   width: 150,
    //   headerAlign: "center",
    //   getActions: (params) => [
    //     <GridActionsCellItem
    //       icon={<CustomerIcon />}
    //       label="View Customer"
    //       onClick={() => handleViewCustomer(params.row)}
    //     />,
    //     <GridActionsCellItem
    //       icon={<ImpersonationIcon />}
    //       label={t("Impersonation")}
    //       onClick={() => handleImpersonation(params)}
    //     />,

    //     <GridActionsCellItem
    //       icon={<InvoiceIcon />}
    //       label={t("INVOICE")}
    //       onClick={() => handleInvoice(params.row)}
    //     />,
    //   ],
    // },
  ]);

  return (
    <>
      <HeaderToolbar title={t("DEALERDETAILS")} />

      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        style={{ marginLeft: "20px" }}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>

        <Box item style={{ margin: "0 8px" }}>
          <Tooltip title={t("FILTER")} onClick={handleFilterIcon}>
            <img src={filterIcon} />
          </Tooltip>
        </Box>

        <Box item style={{ margin: "0 8px" }}>
          {/* <Tooltip title={t("EXPORT")} onClick={handleDownload}>
            <img src={forwardIcon} />
          </Tooltip> */}

          <ExportDialog
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleExportCustomer(data)}
            totalRecords={totalRecords}
            nameTitle={"Export Dealer"}
            handleFileFormatChange={handleFileFormatChange}
            handleDataRecordsChange={handleDataRecordsChange}
            handleInputChange={handleInputChange}
            handleToInputChange={handleToInputChange}
            fileFormat={fileFormat}
            noOfRecords={noOfRecords}
            inputValue={inputValue}
            toInputValue={toInputValue}
            setFileFormat={setFileFormat}
            setNoOfRecords={setNoOfRecords}
            setInputValue={setInputValue}
            setToInputValue={setToInputValue}
            setIsLivePhoto={setIsLivePhoto}
            setIsSignature={setIsSignature}
            isLivePhoto={isLivePhoto}
            isSignature={isSignature}
            handleCheckBoxLivePhoto={handleCheckBoxLivePhoto}
            handleCheckBoxSignature={handleCheckBoxSignature}
            dealerPortal={true}
            closemodel={closemodel}
            setClosemodel={setClosemodel}
          />
        </Box>

        <Box item>
          <Search
            onSearch={(e) => globalsearch(e)}
            clearSearch={() => loadData(filter, paging)}
          />
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%", marginTop: "15px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {openFilter && (
        <DealerReportFilter
          open={openFilter}
          onClose={() => {
            setOpenFilter(false);
          }}
          date={date}
          rowsPerPage={rowsPerPage}
          applyFilter={applyFilter}
        />
      )}
      {openDownload && (
        <DealerTransactionAndReportExports
          open={openDownload}
          handleClose={() => {
            setOpenDownload(false);
          }}
          filter={filter}
        />
      )}
    </>
  );
}

export default DealersReport;
